// extracted by mini-css-extract-plugin
export default {"carousel":"_1NRRskikgFmpgf66UVZo9h","defaultSizing":"_2DWQHV09vZZKdEZdIR2VxB"};